export class ReceiverEmailViewModel {
  constructor(
    public email: string,
    public emails: string[],
    public affair: string,
    public bodyHtml: string,
    public sendAttached: boolean,
    public attachedFiles: any
  ) {}
}
